import React from 'react';
import { SectionDivider } from '../components/SectionDivider';
import { Calendar, Clock, ArrowLeft } from 'lucide-react';
import { BlogCard } from '../components/BlogCard';
interface BlogPostLayoutProps {
  title: string;
  metaDescription: string;
  date: string;
  readTime: string;
  content: React.ReactNode;
  faqs?: {
    q: string;
    a: string;
  }[];
  relatedPosts?: {
    title: string;
    excerpt: string;
    slug: string;
    date: string;
    readTime: string;
  }[];
}
export function BlogPostLayout({
  title,
  metaDescription,
  date,
  readTime,
  content,
  faqs,
  relatedPosts
}: BlogPostLayoutProps) {
  return <div className="min-h-screen bg-[#050505] text-white pt-24" data-id="element-799">
      {/* Back Link */}
      <div className="max-w-3xl mx-auto px-4 md:px-6 mb-8" data-id="element-800">
        <a href="/blog" onClick={e => {
        e.preventDefault();
        window.history.pushState({}, '', '/blog');
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo(0, 0);
      }} className="inline-flex items-center text-white/50 hover:text-[#c9a84c] transition-colors" data-id="element-801">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-802" />
          Back to Blog
        </a>
      </div>

      {/* Header */}
      <article className="px-4 md:px-6" data-id="element-803">
        <header className="max-w-3xl mx-auto mb-12 text-center" data-id="element-804">
          <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-805">
            {title}
          </h1>
          <div className="flex items-center justify-center space-x-6 text-sm text-white/50" data-id="element-806">
            <div className="flex items-center space-x-2" data-id="element-807">
              <Calendar className="w-4 h-4" data-id="element-808" />
              <span data-id="element-809">{date}</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-810">
              <Clock className="w-4 h-4" data-id="element-811" />
              <span data-id="element-812">{readTime}</span>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="max-w-3xl mx-auto prose prose-invert prose-lg prose-headings:text-white prose-a:text-[#c9a84c] hover:prose-a:text-[#b09242] prose-strong:text-white mb-16" data-id="element-813">
          {content}
        </div>

        {/* FAQ Section (Optional) */}
        {faqs && faqs.length > 0 && <div className="max-w-3xl mx-auto mb-16 bg-[#0a0a0a] border border-white/10 rounded-xl p-8" data-id="element-814">
            <h2 className="text-2xl font-bold mb-6" data-id="element-815">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6" data-id="element-816">
              {faqs.map((faq, idx) => <div key={idx} className="border-b border-white/10 pb-4 last:border-0 last:pb-0" data-id="element-817">
                  <h3 className="text-lg font-medium text-[#c9a84c] mb-2" data-id="element-818">
                    {faq.q}
                  </h3>
                  <p className="text-white/70 text-sm" data-id="element-819">{faq.a}</p>
                </div>)}
            </div>
          </div>}

        <SectionDivider data-id="element-820" />

        {/* CTA */}
        <div className="max-w-3xl mx-auto text-center py-12" data-id="element-821">
          <h2 className="text-2xl font-bold mb-4" data-id="element-822">
            Need a Professional Website?
          </h2>
          <p className="text-white/60 mb-8" data-id="element-823">
            Get a custom-built website for your Dublin business for just €249.
          </p>
          <a href="/contact" onClick={e => {
          e.preventDefault();
          window.history.pushState({}, '', '/contact');
          window.dispatchEvent(new PopStateEvent('popstate'));
          window.scrollTo(0, 0);
        }} className="inline-block bg-[#c9a84c] text-black font-bold px-8 py-3 rounded-lg hover:bg-[#b09242] transition-colors" data-id="element-824">
            Get a Quote Today
          </a>
        </div>

        {/* Related Posts */}
        {relatedPosts && relatedPosts.length > 0 && <div className="max-w-6xl mx-auto py-16 border-t border-white/10" data-id="element-825">
            <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-826">
              Related Articles
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-827">
              {relatedPosts.map((post, idx) => <BlogCard key={idx} {...post} data-id="element-828" />)}
            </div>
          </div>}
      </article>
    </div>;
}